import { createFileRoute } from '@tanstack/react-router';
import { PeriodPage } from '@/features/accounting/period-page';
import { AccountingGuard } from '@/features/accounting/guard';

export const Route = createFileRoute('/_app/accounting/period')({ component: () => <AccountingGuard><PeriodPage /></AccountingGuard> });
